import Form from 'src/utils/Form.js'

class User extends Form {
    constructor(data, config = null, responseType = 'json') {
        super(data, config || Form.config, responseType)
    }

    fetch(then) {
        return super.get(`users/${this.id}/edit`).then(data => {
            this.originalData = data
            this.originalData['password'] = '********';
            this.originalData['password_confirmation'] = '********';
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            then(data)
        })
    }

    profile(then) {
        return super.get('me').then(data => {
            this.originalData = data
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            then(data)
        })
    }

    changeEmail(then) {
        return super.post('/change/email').then(data => {
            this.originalData = data
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            then(data)
        })
    }

    getIdDocument(then) {
        return super.get(`users/${this.id}/id-document`).then(data => {
            this.originalData = data
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            then(data)
        })
    }

    static all(parameters, then) {
        return new Form().get('users' + '?' + parameters).then(then)
    }

    static list(parameters, then) {
        return new Form().get(`users/list?${parameters}`).then(then)
    }

    static all_permissions(role_id, then) {
        return new Form().get('permissions/' + role_id).then(then)
    }

    rewards(then) {
        return super.get(`users/${this.id}/rewards`).then(data => {
            this.originalData = data
            for (let field in this.originalData) {
                this[field] = data[field]
            }
            then(data)
        })
    }

    create(then) {
        return super.post('users').then(then)
    }

    setAction(then) {
        return super.post(`users/${this.id}/set-action`).then(then)
    }

    update(then) {
        return super.patch(`users/${this.id}`).then(then)
    }

    updateInline(then) {
        return super.put(`users/${this.id}`).then(then)
    }

    updateAuthenticationStatus(then) {
        return super.put(`users/${this.id}/authentications`).then(then)
    }

    destroy(then) {
        return super.delete('users/' + this.id).then(then)
    }

    sendEmail(then) {
        return super.post(`users/${this.id}/send-email`).then(then)
    }

    grant(then) {
        return super.post(`users/${this.id}/grant`).then(then)
    }

    storeIdDocument(then) {
        return super.post(`users/${this.id}/id-document`).then(then)
    }

    storeImage(then) {
        const fd = this.formData(['image'])

        return super.post(`/users/${this.id}/store-image`, fd).then(({message}) => {
            then(message)
        })
    }

    deleteImage(then) {
        return super.post(`/users/${this.id}/delete-image`).then(({message}) => {
            then(message)
        })
    }

    googleFormViewed(then) {
        return super.post(`google/form/viewed`).then(then)
    }

    updateAddressProof(then) {
        const fd = this.formData(['documents'])

        return super.post(`update-address-proof`, fd).then(then)
    }

    static addresses(parameters, then) {
        return new Form().get(`address?${parameters}`).then(then)
    }

    preferences(then) {
        return super.post(`users/${this.id}/preferences`).then(then)
    }

    setUserCountry(then) {
        return super.post('users/set-country').then(then)
    }

}

export default User
